import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";

import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { Typography } from "@mui/material";
// Components
import MuiLoader from "../../components/MuiLoader";
import ContentEditor from "../../components/ContentEditor";
import ContentPreview from "../../components/ContentPreview";
import Swal from "sweetalert2";
import CategoryIcon from "@mui/icons-material/Category";
// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// MUI
import { AppBar, Tabs, Tab } from "@mui/material";
import PropTypes from "prop-types";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";

// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  Chip,
  Divider,
  Stack,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import { red, blue, green, purple } from "@mui/material/colors";
import Carousel from "react-material-ui-carousel";
import { Paper } from "@mui/material";
import { getMediaUrl } from "../../utils/mediaUtils";

// API'S

// API'S
// import { getAllModules, getAllSubModules, getAllTopics, getAllContents, updateAllContents, deleteAllContents, createAllQuizContents, getAllQuizContents, deleteAllQuizs } from "./FlnActivity.Thunk";
// import {
//   getAllContents,
//   getAllSkillQuiz,
//   saveFlnSkillQuiz,
//   updateFlnSkillQuiz,
//   deleteFlnSkillQuiz,
// } from "./FlnActivity.Thunk";

import {
  getAllContents,
  getAllSkillQuiz,
  saveFlnSkillQuiz,
  updateFlnSkillQuiz,
  deleteFlnSkillQuiz,
} from "../FlnActivity/FlnActivity.Thunk";
// import {
//   getTeacherBaselineFlnThunk,
//   getTeacherBaselineEceThunk,
//   getTeacherBaselineCommunityThunk,
//   deleteTeacherBaselineThunk,
// } from "../FlnTopics/FlnTopicsThunk";

// import {
//   getTeacherBaselineFlnThunkSkill,
//   getTeacherBaselinePgeThunkSkill,
//   getTeacherBaselineEceThunkSkill,
// } from "../FlnSkill/FlnSkillThunk";

import { getSkills } from "./FlnActivity.Thunk";
// import {
//   getAllContents,
//   getAllSkillQuiz,
//   saveFlnSkillQuiz,
//   updateFlnSkillQuiz,
//   deleteFlnSkillQuiz,
// } from "./FlnActivity.Thunk";

// import {
//   getAllContents,
//   getAllSkillQuiz,
//   saveFlnSkillQuiz,
//   updateFlnSkillQuiz,
//   deleteFlnSkillQuiz,
// } from "../FlnActivity/FlnActivity.Thunk";
import {
  getMasterStudActTopicsThunk,
  deleteTeacherBaselineThunk,
} from "../FlnTopics/FlnTopicsThunk";

// import { getSkills } from "./FlnActivity.Thunk";
// Components
import MuiHeader from "../../components/MuiHeader";
// import TemplateMaster from "../template-master/TemplateMaster";
import FlnTemplate from "../template-master/FlnTemplate";
import api from "../../api/api";
import QuizTemplete from "../quiz_template/QuizTemplete";
// import { clear_data_skill } from "../FlnSkills/FlnSkillsSlice";
import { clear_data_skill } from "../FlnSkill/FlnSkillSlice";
import { clearData } from "../FlnTopics/FlnTopicsSlice";

// import Quiz from "../quiz_template/Quiz";
// import { setTopicId, setTopicName, setOption } from "./FlnActivitySlice";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};

const TrainingActivity = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);

  // To create Topic
  const navigateToTopic = () => {
    setClas("");
    setSubject("");
    dispatch(clear_data_skill());
    navigate("/flntopic");
  };

  // To create Skill
  const navigateToSkill = () => {
    setClas("");
    setSubject("");
    dispatch(clearData());
    navigate("/flnSkill");
  };

  const onTabChange = (event, index) => {
    setTabIndex(index);
  };

  const onTabIndexChange = (index) => {
    setTabIndex(index);
  };

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------
  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { id: 0, value: "od", text: "ଓଡିଆ" },
    { id: 1, value: "en", text: "English" },
  ];

  const usertype_select_option_list = [
    { id: 0, value: "fellow", text: "Educator" },
    { id: 1, value: "anganwadi", text: "Anganwadi" },
    { id: 2, value: "school", text: "School" },
    { id: 3, value: "cci", text: "CCI" },
  ];

  const assessmentType_select_option_list = [
    { id: 0, value: "formative", text: "Formative Assessment" },
    { id: 1, value: "summative", text: "Summative Assessment" },
  ];

  // Same Class/Subject filters as the Topic creation page (FlnTopicsPage.js)
  const clas_select_option_list = [
    { value: "SV", text: "Shishu Vatika" },
    ...Array.from({ length: 10 }, (_, i) => ({
      value: String(i + 1),
      text: `Class ${i + 1}`,
    })),
  ];

  const subject_select_option_list = [
    { value: "maths", text: "Maths" },
    { value: "english", text: "English" },
    { value: "odia", text: "Odia" },
    { value: "evs", text: "EVS" },
    { value: "numeracy", text: "Numeracy" },
    { value: "literacy", text: "Literacy" },
    { value: "sst", text: "SST" },
    { value: "science", text: "Science" },
  ];

  const answerType_label = {
    yesNoOptions: "Yes / No",
    "2options": "2 Options",
    "3options": "3 Options",
    "4options": "4 Options",
    textInput: "Text Answer",
    documentInput: "Document",
    imageInput: "Image",
    audioInput: "Audio",
    videoInput: "Video",
  };

  // ------------------------------------------------------------

  const languages = useSelector((state) => state.FlnActivitySlice.language);
  // const { topicId, topicName, option } = useSelector(
  //   (state) => state.FlnActivitySlice
  // );

  // const skills = useSelector((state) => state?.FlnSkillSlice?.skill);
  // console.log("check skilss-------->", skills);

  const [language, setLanguage] = useState("od");
  const [usertype, setUsertype] = useState("fellow");
  const [assessmentType, setAssessmentType] = useState("");
  console.log("assessmentType", assessmentType);
  const [modules, setModules] = useState([]);
  const [moduleid, setModuleid] = useState("");
  const [submodules, setSubmodules] = useState([]);
  const [submoduleid, setSubmoduleid] = useState("");
  const [topics, setTopics] = useState([]);
  // const [skillId, setskillId] = useState("");
  // //console.log("skillId----->", skillId);
  const [disable_content_button, setDisable_content_button] = useState(true);
  const [disable_quiz_button, setDisable_quiz_button] = useState(true);

  const [contentDetails, setContentDetails] = useState([]);
  const [contents, setContents] = useState([]);
  //console.log("contents", contents);
  const [contentId, setContentId] = useState("");
  const [quiz, setQuizs] = useState([]);
  //console.log("quiz---->", quiz);
  const [showUpdate, setShowUpdate] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedSegment, setSelectedSegment] = useState({});
  const [selectedSegmentQuiz, setSelectedSegmentQuiz] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const [loading, setLoading] = useState(false);

  // -------------- Preview -----------------------
  const [openPreview, setOpenPreview] = useState(false);
  const [previewContenttitle, setPreviewContenttitle] = useState("");
  const [previewContent, setPreviewContent] = useState("");
  // //console.log("previewContent-------->", previewContent.length);
  const [topic, setTopic] = useState([]);
  const [topicId, setTopicId] = useState("");
  const [topicName, setTopicName] = useState("");
  // const [option, setOption] = useState();
  // const [optionValue, setOptionValue] = useState();
  // //console.log("topic", topic);
  const [updateData, setUpdateData] = useState({
    skillId: "",
    quizData: [
      {
        optionA: "",
        optionB: "",
        optionC: "",
        optionD: "",
        correctAnswer: "",
        questionOrder: "",
        question: "",
      },
    ],
  });

  const contentOnClick = (segment) => {
    setPreviewContenttitle(segment.displayname);
    setPreviewContent(segment.contentData);
    setOpenPreview(true);
  };

  const handleClosePreview = () => {
    setOpenPreview(false);
  };
  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  // ----------- create, update delete button click ----------

  const [params, setParams] = useState({});
  const [show, setShow] = useState(false);

  const create_content_button_click = () => {
    // --------------- nrusingh: modified on 28-06-2023 ---------------
    if (contents.length > 0)
      Swal.fire(
        "Error",
        "Could not create content. Content for this topic is already exists.",
        "error"
      );
    else {
      const params = {
        operation: "save",
        language: language,
        usertype,
        topicId: topicId,
        contentData: contents,
      };
      setParams(params);
      setOpenEditor(true);
    }

    // ----------------------------------------------------------------
  };

  const language_select_onchange = (event) => {
    setLanguage(event.target.value);
    setUsertype("");
    setAssessmentType("");
    setContentId("");
    setTopic([]);
    setContents([]);
    setQuizs([]);
    setContentDetails([]);
  };
  const usertype_select_onchange = (event) => {
    setUsertype(event.target.value);
    setAssessmentType("");
    setClas("");
    setSubject("");
    setContentId("");
    setTopic([]);
    setContents([]);
    setContentDetails([]);
  };

  const AssessmentType_select_onchange = (event) => {
    setAssessmentType(event.target.value);
    setClas("");
    setSubject("");
    setContentId("");
    setTopic([]);
    setContents([]);
    setContentDetails([]);
  };

  const clas_select_onchange = (event) => {
    setClas(event.target.value);
    setContentId("");
    setTopic([]);
    setContents([]);
    setQuizs([]);
    setSubject("");
    setContentDetails([]);
  };

  // Same Class + Subject topic lookup as the Topic creation page
  const subject_select_onchange = (event) => {
    const newSubject = event.target.value;
    setSubject(newSubject);
    setContents([]);
    setTopic([]);
    dispatch(
      getMasterStudActTopicsThunk({
        usertype,
        language,
        assessType: assessmentType,
        quizClass: clas,
        subject: newSubject,
      })
    )
      .then((response) => {
        setTopic(response?.payload?.length > 0 ? response?.payload : []);
      })
      .catch((error) => {
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
        return false; // Prevent Swal from closing
      });
  };

  const topic_select_onchange = (event, value) => {
    // content and quiz are both scoped directly to the selected topic
    setContent([]);
    setQuizs([]);
    if (event && event.target && event.target.value) {
      setTopicId(event.target.value);
      setTopicName(value.props.children);
      const params = { topicId: event.target.value };
      setLoading(true);
      getAllContents(params).then((response) => {
        setContents(Array.isArray(response?.data) ? response.data : []);
        console.log("content=====>", response);
        setLoading(false);
        setDisable_content_button(false);
      });

      getAllSkillQuiz(params)
        .then((response) => {
          setQuizs(response);
          setDisable_quiz_button(false);
        })
        .catch((error) => {
          console.error("Failed to load quiz for topic:", error);
          toast.error("Failed to load quiz for this topic.");
        });
    } else {
      // Handle the case when event or its properties are undefined
      console.error("Event object or its properties are undefined");
    }
  };

  // -------------- Editor -----------------------

  const [openEditor, setOpenEditor] = useState(false);
  const [operation, setOperation] = useState("");
  const [contenttitle, setContenttitle] = useState("");
  const [content, setContent] = useState();
  const [contentduration, setContentduration] = useState(0);
  const [contenttype, setContenttype] = useState("content");
  const [index, setIndex] = useState(-1);
  const [questionId, setQuestionId] = useState("");
  const [clas, setClas] = useState("");
  const [subject, setSubject] = useState("");

  const handleCloseEditor = () => {
    // _loaddata();
    setOpenEditor(false);
  };
  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  const handleVertMenuClick = (event, eachsegment, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setSelectedSegment(eachsegment);
    setSelectedSegmentQuiz(eachsegment);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedIndex(-1);
    setSelectedSegment({});
    setSelectedSegmentQuiz({});
  };

  //on update
  // const update_content_button_click = (eachsegment, index) => {
  //   //console.log(eachsegment, "eachsegment");
  //   handleVertMenuClose();
  //   setOperation("update");
  //   setContenttitle(eachsegment.skillName);
  //   setContent(eachsegment.contentData);
  //   //setContentid(eachsegment.skillId);
  //   setIndex(index);
  //   setOpenEditor(true);
  // };

  const update_content_button_click = () => {
    if (contents.length <= 0)
      Swal.fire(
        "Error",
        "No content found. There is no content found to update, please select a content.",
        "warning"
      );
    else {
      const params = {
        operation: "update",
        language: language,
        usertype: usertype,
        topicId: topicId,
        contentData: contents,
      };
      setParams(params);
      setOpenEditor(true);
    }
  };

  const saveEditorContentData = (editor_data) => {
    setOpenEditor(false);
    if (editor_data.operation === "save") {
      //console.log(contentDetails, "contentDetails", editor_data, "editor_data");
      if (contentDetails.length > 0) {
        const data = {
          // usertype: usertype,
          // trainingType: "training",
          contentData: editor_data.content,
        };
        //console.log("data------->", data);
        // updateAllContents(data).then((response) => {
        //   //console.log(response.data, "create training------------------->");
        //   if (response.data.status === "success") _loaddata();
        // }
        // );
      }
    } else if (editor_data.operation === "update") {
      //console.log("editorupdate------->", editor_data.content.length);
      if (editor_data.content.length > 2) {
        const data = {
          // usertype: usertype,
          // trainingType: "training",
          contentData: editor_data.content,
        };
        //console.log("data------->", data);
        // updateAllContents(data).then((response) => {
        //   //console.log(response.data, "create training------------------->");
        //   if (response.data.status === "success") _loaddata();
        // });
      }
    }
  };
  //on Delete
  // const delete_content_button_click = (eachsegment, index) => {
  // const delete_content_button_click = () => {
  //   handleVertMenuClose();
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Once deleted, you will not be able to recover this record!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     //cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       const data = {
  //         skillId,
  //         contentId,
  //       };
  //       // deleteAllContents(data).then((response) => {
  //       //   //console.log("delete data response -->", response.data);
  //       //   if (response.data.status === "success") _loaddata();
  //       // });
  //     }
  //   });
  // };

  //----------------------------create ,update,delete quiz -----------------------//
  // states
  const [isLoading, setIsLoading] = useState(false);
  const [showQuizDialog, setShowQuizDialog] = useState(false);
  const [action, setAction] = useState("");
  const [data, setData] = useState(null);

  const quiz_on_close = () => setShowQuizDialog(false);
  const quiz_on_open = (action, quizObject) => {
    //console.log(quizObject, action, "quizObj");
    const param = { action: action, quizObject: quizObject };
    setAction(action);
    setData(param);
    setShowQuizDialog(true);
  };
  // //console.log(action, "myAct");
  const quiz_on_save = (quizdata) => {
    // //console.log("quizData", quizdata);
    // if (!Array.isArray(quizdata)) {
    //   quizdata = [...quiz, quizdata]; // Push the object to the array if it's not an array
    // } else {
    //   quizdata; // Use the array directly if it's already an array
    // }

    if (action === "save") save_quiz_data(quizdata);
    else if (action === "update") update_quiz_data(quizdata);
    else if (action === "update") update_quiz_data(quizdata);
  };

  // const save_quiz_data = (quizdata) => {
  //   setIsLoading(true);
  //   const newdata = {
  //     skillId: skillId,
  //     quizData: [...quiz, quizdata],
  //   };
  //   setShowQuizDialog(false);
  //   dispatch(saveFlnSkillQuiz(newdata))
  //     const prm = { usertype, skillId: skillId, language };
  //     //console.log("prmmmmmmm", prm);
  //     getAllSkillQuiz(prm).then((response) => {
  //       //console.log("getAllSkillQuiz---->", response);
  //       setDisable_quiz_button(false);

  //   });
  // };
  let updatedQuizzes = [];

  const save_quiz_data = (quizdata) => {
    // Assuming 'quiz' represents the existing quizzes array
    if (typeof quizdata === "object" && !Array.isArray(quizdata)) {
      // If 'quizdata' is an object, push it to the updatedQuizzes array
      updatedQuizzes.push(quizdata);
    }
    const updatedQuizze = Array.isArray(quiz)
      ? [...quiz, ...updatedQuizzes]
      : [...updatedQuizzes]; // Combine existing and new quiz data

    setIsLoading(true);
    const newdata = {
      language,
      topicId: topicId,
      topicName: topicName,
      usertype: usertype,
      assessType: assessmentType,
      subject: subject,
      quizClass: clas,
      quizData: updatedQuizze, // Use the updated quizzes array here
    };
    setShowQuizDialog(false);

    // Dispatch the action and fetch data sequentially
    dispatch(saveFlnSkillQuiz(newdata))
      .then(() => {
        const prm = { topicId: topicId };
        return getAllSkillQuiz(prm);
      })
      .then((response) => {
        setQuizs(response);
        setDisable_quiz_button(false);
      })
      .catch((error) => {
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error(
            "An unexpected error occurred. Please try again later."
          );
        }
        return false; // Prevent Swal from closing
      });
  };

  const update_quiz_data = (quizdata) => {
    //console.log("quizdata---->", quizdata);
    const updateDataSet = quiz.map((item) => {
      if (item.questionId === quizdata.questionId) {
        return {
          ...item,
          ...quizdata,
        };
      }
      return item;
    });

    const data = {
      language,
      topicId: topicId,
      topicName: topicName,
      usertype: usertype,
      assessType: assessmentType,
      subject: subject,
      quizClass: clas,
      quizData: updateDataSet,
    };

    setShowQuizDialog(false);
    dispatch(updateFlnSkillQuiz(data))
      .then(() => {
        const params = { topicId: topicId };
        return getAllSkillQuiz(params);
      })
      .then((response) => {
        setQuizs(response);
        setDisable_quiz_button(false);
      })
      .catch((error) => {
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
        return false; // Prevent Swal from closing
      });
  };

  // const delete_quiz_button_click = (skillId) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Do you want to delete all question, you will not be able to recover this record!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       dispatch(deleteFlnSkillQuiz(skillId)).then(() => {
  //         const params = { usertype, skillId, language };
  //         // dispatch(getQuizThunk(params));
  //         getAllSkillQuiz(params).then((response) => {
  //           //console.log("getAllSkillQuiz---->", response);
  //           setDisable_quiz_button(false);
  //         });
  //         toast.success("Successfully Deleted");
  //       });
  //     }
  //   });
  // };

  // ------------------- OPERATIONS ----------------------
  const _loaddata = () => {
    // getAllContents({ skillId }).then((content) => {
    //   //console.log("@@@2 content", content);
    //   if (Object.keys(content.data).length > 0) {
    //     setContentId(content.data.contentId ? content.data.contentId : "");
    //     setContents(content.data.contentData ? content.data.contentData : []);
    //     setQuizs(content.data.quizData ? content.data.quizData : []);
    //     setContentDetails(content.data);
    //   }
    // });
  };
  const _savedata = () => { };
  const _updatedata = () => { };
  const _deletedata = () => { };
  // -----------------------------------------------------
  //--------------------quiz part end------------------------------//
  // const delete_quiz_button_click = (skillId) => {
  //   // //console.log("data--->", data);
  //   handleVertMenuClose();
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Once deleted, you will not be able to recover this record!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     //cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       // data = {
  //       //   skillId: skillId,
  //       // }
  //       // //console.log("data====>",data);
  //       deleteFlnSkillQuiz(skillId).then((response)=>{
  //         // //console.log("response===>",response);
  //         // if (response.data.status === "success") {
  //         //   const body = { usertype, language,skillId };
  //         //   dispatch(getAllSkillQuiz(body));
  //         //   toast.success("Changes made successfully");
  //         // }
  //       })

  //       // //console.log("delete id---->", data);
  //     }
  //   });
  // };

  //console.log("topicid===>", skillId);
  //console.log("skillId====>", skillId);
  //console.log("skill===>", skill);

  const delete_quiz_button_click = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete all question, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const data4 = {
          topicId: topicId,
        };
        dispatch(deleteFlnSkillQuiz(data4))
          .then(() => {
            const params = { topicId: topicId };
            return getAllSkillQuiz(params);
          })
          .then((response) => {
            //console.log("getAllSkillQuiz---->", response);
            setQuizs(response);
            setDisable_quiz_button(false);
          })
          .catch((error) => {
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
            return false; // Prevent Swal from closing
          });
      }
    });
  };

  const deleteFileFromDB = (item) => {
    api
      .delete(
        `deleteFile/${
        // item.questionMedia.split("/")[
        //   item.questionMedia.split("/").length - 1
        // ]
        item
        }`
      )
      .then((res) => {
        if (res.status === 200) {
          console.log("This has been called perhaps...");
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
        return false; // Prevent Swal from closing
      });
  };

  const delete_quiz_single_click = (item) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteFileFromDB(item.questionMedia);
        const newquiz = quiz.filter(
          (itm) => itm.questionId !== item.questionId
        );
        const data6 = {
          topicId: topicId,
          quizData: newquiz,
        };

        dispatch(updateFlnSkillQuiz(data6))
          .then(() => {
            const params = { topicId: topicId };
            return getAllSkillQuiz(params);
          })
          .then((response) => {
            //console.log("getAllSkillQuiz---->", response);
            setQuizs(response);
            setDisable_quiz_button(false);
          })
          .catch((error) => {
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
            return false; // Prevent Swal from closing
          });
      }
    });
  };

  function getYouTubeId(url) {
    let videoId = "";
    const regExp = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
      videoId = match[2];
    }
    return videoId;
  }

  useEffect(() => {
    if (openEditor === true) {
      setContents([]);
    } else {
      if (topicId) {
        getAllContents({ topicId: topicId })
          .then((res) => {
            if (res.status === 200) {
              setContents(res.data);
            }
          })
          .catch((error) => console.error("The error---->", error));
      }
    }
  }, [openEditor]);

  // console.log("skills------------------------------>", skills);
  // console.log("contents------------------------------------>", contents);
  // console.log("topicId--------------->", topicId);
  return (
    <>
      <MuiHeader header="New Student Activity (FLN/PGE/ECE/Community)" />
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Language</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={language}
                label="Language"
                onChange={language_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language_select_option_list.map((option) => (
                  <MenuItem key={option.id} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Usertype</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={usertype}
                label="Language"
                onChange={usertype_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language &&
                  usertype_select_option_list.map((option) => (
                    <MenuItem key={option.id} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">AssessType</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={assessmentType}
                label="AssessType"
                onChange={AssessmentType_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language &&
                  usertype &&
                  assessmentType_select_option_list.map((option) => (
                    <MenuItem key={option.id} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Class</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={clas}
                label="Class"
                onChange={clas_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language &&
                  usertype &&
                  assessmentType &&
                  clas_select_option_list.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Subject</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={subject}
                label="Subject"
                onChange={subject_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language &&
                  usertype &&
                  assessmentType &&
                  clas &&
                  subject_select_option_list.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Topic</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                label="Topic"
                value={topicId}
                onChange={topic_select_onchange}
              >
                {topic &&
                  topic?.length > 0 &&
                  topic?.map((option) => (
                    <MenuItem key={option?.topicId} value={option?.topicId}>
                      {option?.topicName}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </div>
      <div style={{ marginTop: 40 }}>
        {/* <Button
          onClick={navigateToSkill}
          variant="outlined"
          sx={{ m: 1, marginTop: -5, backgroundColor: "blue", height: "40px" }}
          size="small"
        >
          <CategoryIcon
            style={{
              color: "orange",
              marginTop: "-3px",
            }}
          ></CategoryIcon>
          <b style={{ color: "black" }}>Skill</b>
        </Button> */}
        <Button
          onClick={navigateToTopic}
          variant="outlined"
          sx={{ m: 1, marginTop: -5, backgroundColor: "blue", height: "40px" }}
          size="small"
        >
          <CategoryIcon
            style={{
              color: "orange",
              marginTop: "-3px",
            }}
          ></CategoryIcon>
          <b style={{ color: "black" }}>Topic</b>
        </Button>
        {/* <Button
          onClick={navigateToSummativeTopic}
          variant="outlined"
          sx={{ m: 1, marginTop: -5, backgroundColor: "blue", height: "38px" }}
          size="small"
        >
          <CategoryIcon
            style={{
              color: "orange",
              marginTop: "-3px",
            }}
          ></CategoryIcon>
          <b style={{ color: "black" }}>Summative Topic</b>
        </Button> */}
      </div>
      {/* Show List */}
      <div>
        {topic && topic.length > 0 ? (
          <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
            <AppBar
              position="static"
              style={{ background: "#dedede", color: "black" }}
            >
              <Tabs
                value={tabIndex}
                onChange={onTabChange}
                indicatorColor="primary"
                textColor="inherit"
                variant="fullWidth"
                aria-label="full width tabs example"
              >
                <Tab label="Content" {...a11yProps(0)} />
                <Tab label="Quiz" {...a11yProps(1)} />
              </Tabs>
            </AppBar>
            {
              <div
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={tabIndex}
                onChangeIndex={onTabIndexChange}
              >
                {assessmentType === "formative" ? (
                  <TabPanel value={tabIndex} index={0} dir={theme.direction}>
                    {/* Content part start */}
                    {/* Preview */}
                    {/* update_content_button_click(selectedSegment, selectedIndex)
                delete_content_button_click(selectedSegment, selectedIndex) */}
                    <>
                      <Button
                        onClick={create_content_button_click}
                        variant="contained"
                        disabled={disable_content_button}
                      >
                        Create New Content
                      </Button>
                      {contents && contents.length ? (
                        <div>
                          {/* <Button color="error" onClick={delete_content_button_click}>
                      <HighlightOffIcon />
                    </Button> */}
                          <Button onClick={update_content_button_click}>
                            <DriveFileRenameOutlineIcon />
                          </Button>
                        </div>
                      ) : null}
                      {contents && contents?.length > 0 ? (
                        <div className="outer-preview">
                          <div className="inner-preview">
                            {contents?.map((object, index) => (
                              <div key={index}>
                                <div>
                                  {object.type === "text" && (
                                    <>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: object.label,
                                        }}
                                        style={{ wordWrap: "break-word" }}
                                      ></div>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: object.value,
                                        }}
                                        style={{ wordWrap: "break-word" }}
                                      ></div>
                                    </>
                                  )}

                                  {object.type === "image" && (
                                    <>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: object.label,
                                        }}
                                        style={{ wordWrap: "break-word" }}
                                      ></div>
                                      <div>
                                        <img
                                          src={getMediaUrl(object.value)}
                                          width="90%"
                                          alt=""
                                        />
                                      </div>
                                    </>
                                  )}

                                  {object.type === "audio" && (
                                    <>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: object.label,
                                        }}
                                        style={{ wordWrap: "break-word" }}
                                      ></div>
                                      <div>
                                        <audio
                                          controls
                                          style={{ width: "90%" }}
                                        >
                                          <source
                                            src={getMediaUrl(object.value)}
                                          />
                                        </audio>
                                      </div>
                                    </>
                                  )}

                                  {object.type === "video" && (
                                    <>
                                      <div>
                                        <div>{object.label}</div>
                                        {object.type === "video" &&
                                          object.thumbnail !== "" ? (
                                          <>
                                            <img
                                              src={getMediaUrl(
                                                object.thumbnail
                                              )}
                                              width="90%"
                                              alt=""
                                            />
                                          </>
                                        ) : null}

                                        <video controls width="100%">
                                          <source
                                            src={getMediaUrl(object.value)}
                                          />
                                        </video>
                                      </div>
                                    </>
                                  )}

                                  {object.type === "youtube" && (
                                    <>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: object.label,
                                        }}
                                        style={{ wordWrap: "break-word" }}
                                      ></div>
                                      <div>
                                        <iframe
                                          title="YouTube Video"
                                          width="320"
                                          height="195"
                                          src={`https://www.youtube.com/embed/${object.value}`}
                                          frameborder="0"
                                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                          allowfullscreen
                                        ></iframe>
                                      </div>
                                    </>
                                  )}

                                  {object.type === "slider" && (
                                    <>
                                      <div style={{}}>
                                        <div>{object.label}</div>
                                        {Array.isArray(object.value) ? (
                                          <Carousel
                                            style={{
                                              display: "block",
                                              marginTop: "10px",
                                            }}
                                          >
                                            {object.value.map((url, index) => (
                                              <Paper
                                                key={index}
                                                style={{
                                                  width: "100%",
                                                  padding: "5px",
                                                }}
                                              >
                                                <img
                                                  src={getMediaUrl(url)}
                                                  width="100%"
                                                  alt=""
                                                  style={{
                                                    width: "100%",
                                                    height: "auto",
                                                    display: "block",
                                                  }}
                                                />
                                              </Paper>
                                            ))}
                                          </Carousel>
                                        ) : null}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <h4 style={{ color: "royalblue" }}>
                          No Content Available
                        </h4>
                      )}
                    </>
                    {/* Content part end */}
                  </TabPanel>
                ) : null}
                {
                  <TabPanel
                    key={tabIndex}
                    value={tabIndex}
                    index={1}
                    dir={theme.direction}
                  >
                    <>
                      <Button
                        onClick={() => quiz_on_open("save", null)}
                        variant="contained"
                        disabled={disable_quiz_button}
                      >
                        Create New Quiz
                      </Button>
                      {quiz && quiz.length > 0 && (
                        <Button
                          color="error"
                          onClick={() => delete_quiz_button_click()}
                          variant="contained"
                        >
                          Delete All Quiz
                        </Button>
                      )}
                      {/* </div>
)} */}
                      {quiz && quiz?.length > 0 ? (
                        <Stack spacing={2} sx={{ mt: 2 }}>
                          {quiz?.map((item, index) => {
                            const isOptionType = [
                              "2options",
                              "3options",
                              "4options",
                            ].includes(item.answerType);
                            const correctLetters = Array.isArray(
                              item.correctOption
                            )
                              ? item.correctOption
                              : [];

                            return (
                              <Card
                                key={item.questionId || index}
                                variant="outlined"
                                sx={{ borderRadius: 2 }}
                              >
                                <CardContent>
                                  <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="flex-start"
                                    spacing={1}
                                    flexWrap="wrap"
                                  >
                                    <Typography
                                      variant="subtitle1"
                                      sx={{ fontWeight: 600 }}
                                    >
                                      Q{index + 1}. {item.question}
                                    </Typography>
                                    <Chip
                                      size="small"
                                      color="primary"
                                      variant="outlined"
                                      label={
                                        answerType_label[item.answerType] ||
                                        item.answerType
                                      }
                                    />
                                  </Stack>

                                  {item.instructions ? (
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      sx={{ mt: 1 }}
                                    >
                                      <b>Instruction: </b>
                                      {item.instructions}
                                    </Typography>
                                  ) : null}

                                  {item.questionMedia &&
                                    item.questionMediaType === "image" ? (
                                    <Box sx={{ mt: 1 }}>
                                      <img
                                        src={getMediaUrl(item.questionMedia)}
                                        alt=""
                                        style={{
                                          maxWidth: "220px",
                                          maxHeight: "220px",
                                          borderRadius: 4,
                                        }}
                                      />
                                    </Box>
                                  ) : item.questionMedia &&
                                    item.questionMediaType === "audio" ? (
                                    <Box sx={{ mt: 1 }}>
                                      <audio controls>
                                        <source
                                          src={getMediaUrl(item.questionMedia)}
                                        />
                                      </audio>
                                    </Box>
                                  ) : item.questionMedia &&
                                    item.questionMediaType === "video" ? (
                                    <Box sx={{ mt: 1 }}>
                                      <video controls width="220">
                                        <source
                                          src={getMediaUrl(item.questionMedia)}
                                        />
                                      </video>
                                    </Box>
                                  ) : null}

                                  {isOptionType ? (
                                    <Grid container spacing={1} sx={{ mt: 1 }}>
                                      {["A", "B", "C", "D"].map((letter) => {
                                        const value =
                                          item[`option${letter}`];
                                        if (!value) return null;
                                        const isCorrect = correctLetters.includes(
                                          letter.toLowerCase()
                                        );
                                        return (
                                          <Grid item xs={12} sm={6} key={letter}>
                                            <Box
                                              sx={{
                                                p: 1,
                                                borderRadius: 1,
                                                border: "1px solid",
                                                borderColor: isCorrect
                                                  ? "success.main"
                                                  : "divider",
                                                bgcolor: isCorrect
                                                  ? "success.50"
                                                  : "transparent",
                                              }}
                                            >
                                              <b>{letter}.</b> {value}
                                              {isCorrect ? " ✓" : ""}
                                            </Box>
                                          </Grid>
                                        );
                                      })}
                                    </Grid>
                                  ) : null}

                                  {(isOptionType ||
                                    item.answerType === "yesNoOptions" ||
                                    item.answer) && (
                                      <Divider sx={{ my: 1.5 }} />
                                    )}

                                  {item.answerType === "yesNoOptions" ? (
                                    <Typography variant="body2">
                                      <b>Correct Answer:</b>{" "}
                                      {correctLetters.join(", ")}
                                    </Typography>
                                  ) : isOptionType ? (
                                    <Typography variant="body2">
                                      <b>Correct Answer:</b>{" "}
                                      {correctLetters
                                        .map((l) => l.toUpperCase())
                                        .join(", ")}
                                    </Typography>
                                  ) : item.answerType === "textInput" ? (
                                    item.answer ? (
                                      <Typography variant="body2">
                                        <b>Answer:</b> {item.answer}
                                      </Typography>
                                    ) : null
                                  ) : item.answerType === "imageInput" ? (
                                    item.answer ? (
                                      <Box>
                                        <Typography
                                          variant="body2"
                                          sx={{ mb: 0.5 }}
                                        >
                                          <b>Answer:</b>
                                        </Typography>
                                        <img
                                          src={getMediaUrl(item.answer)}
                                          alt=""
                                          style={{
                                            maxWidth: "150px",
                                            borderRadius: 4,
                                          }}
                                        />
                                      </Box>
                                    ) : null
                                  ) : item.answerType === "audioInput" ? (
                                    item.answer ? (
                                      <Box>
                                        <Typography
                                          variant="body2"
                                          sx={{ mb: 0.5 }}
                                        >
                                          <b>Answer:</b>
                                        </Typography>
                                        <audio controls>
                                          <source
                                            src={getMediaUrl(item.answer)}
                                          />
                                        </audio>
                                      </Box>
                                    ) : null
                                  ) : item.answerType === "videoInput" ? (
                                    item.answer ? (
                                      <Box>
                                        <Typography
                                          variant="body2"
                                          sx={{ mb: 0.5 }}
                                        >
                                          <b>Answer:</b>
                                        </Typography>
                                        <video controls width="200">
                                          <source
                                            src={getMediaUrl(item.answer)}
                                          />
                                        </video>
                                      </Box>
                                    ) : null
                                  ) : item.answerType === "documentInput" ? (
                                    item.answer ? (
                                      <Typography variant="body2">
                                        <b>Answer:</b>{" "}
                                        <a
                                          href={getMediaUrl(item.answer)}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          View document
                                        </a>
                                      </Typography>
                                    ) : null
                                  ) : null}

                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    justifyContent="flex-end"
                                    sx={{ mt: 2 }}
                                  >
                                    <Button
                                      size="small"
                                      variant="contained"
                                      onClick={() =>
                                        quiz_on_open("update", item)
                                      }
                                    >
                                      Update
                                    </Button>
                                    <Button
                                      size="small"
                                      variant="contained"
                                      color="error"
                                      onClick={() =>
                                        delete_quiz_single_click(item)
                                      }
                                    >
                                      Delete
                                    </Button>
                                  </Stack>
                                </CardContent>
                              </Card>
                            );
                          })}
                        </Stack>
                      ) : (
                        <h4 style={{ color: "royalblue" }}>
                          No Quiz Available
                        </h4>
                      )}
                    </>
                  </TabPanel>
                }
              </div>
            }
          </Box>
        ) : null}
      </div>
      {/* Editor */}
      {/* <ContentEditor open={openEditor} operation={operation} contenttitle={contenttitle} setContenttitle={setContenttitle} setContentduration={setContentduration} content={content} setContent={setContent} index={index} onSave={saveEditorContentData} onClose={handleCloseEditor} />  */}

      <QuizTemplete
        open={showQuizDialog}
        data={data}
        onSubmit={quiz_on_save}
        onClose={quiz_on_close}
      />

      <FlnTemplate
        setContents={setContents}
        topic_select_onchange={topic_select_onchange}
        open={openEditor}
        params={params}
        onClose={handleCloseEditor}
      />

      {/* Preview */}
      <ContentPreview
        open={openPreview}
        contenttitle={previewContenttitle}
        content={previewContent}
        onClose={handleClosePreview}
      />

      {/* Loader */}
      <MuiLoader open={loading} />

      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default TrainingActivity;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
